import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TeamDetailsMachineInfoDto } from '../../../../core/models/teams/team-details-machine-info-dto';
import { MachineListDto } from '../../../../core/models/machines/machine-list-dto';
import { MachineListService } from '../../../../core/services/machine-list/machine-list.service';
import { BehaviorSubject } from 'rxjs';
import { EditablePostClientStatus } from '../../../../core/enums/editable-post-client-status';
import { MachineType } from '../../../../core/enums/machine-type';
import { MatButtonModule } from '@angular/material/button';
import { MatCellDef, MatHeaderCellDef, MatHeaderRowDef, MatRowDef, MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatOptionModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MachineStatus, MachineStatusLabels } from '../../../../core/models/machines/machine-status';

@Component({
  selector: 'app-team-add-machine-dialog',
  imports: [MatIconModule, MatFormFieldModule, MatTooltipModule, MatInputModule, MatSelectModule, FormsModule, MatButtonModule, ReactiveFormsModule, MatCheckboxModule, MatOptionModule, MatProgressSpinnerModule, MatListModule, MatTableModule, MatSortModule, RouterModule, MatDialogModule, MatDialogContent],
  templateUrl: './team-add-machine-dialog.component.html',
  styleUrl: './team-add-machine-dialog.component.scss'
})
export class TeamAddMachineDialogComponent {
  constructor(public dialogRef: MatDialogRef<TeamAddMachineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private machineListService: MachineListService,) { }

  existingMachines: TeamDetailsMachineInfoDto[] = [];
  addedMachines: TeamDetailsMachineInfoDto[] = [];
  allMachines: MachineListDto[] = [];
  showDeactivated: boolean = false;

  allMachines$!: BehaviorSubject<MachineListDto[] | null>;
  machinesDataSource = new MatTableDataSource<MachineListDto>;
  displayColumns = ['select', 'machineId', 'machineTypeText', 'ownerText', 'statusText'];

  ngOnInit(): void {
    this.machineListService.loadMachines();
    this.existingMachines = this.data.team.machines;

    this.allMachines$ = this.machineListService.data$;
    this.allMachines$.subscribe(machines => {
      if (machines !== null) {
        this.allMachines = machines;
        this.sortMachinesBasedOnAssignmentThenMachineId();
        this.machinesDataSource.data = this.allMachines.filter(m =>
          m.baseInfo.machineStatusText === MachineStatusLabels[MachineStatus.Active]);
        this.initializeFilterPredicate();
      }
    })
  }

  private initializeFilterPredicate() {
    this.machinesDataSource.filterPredicate = (machine: MachineListDto, filter: string) => {
      const search = filter.trim().toLowerCase();
      return (
        machine.machineId.toLowerCase().includes(search) ||
        machine.baseInfo.machineTypeText.toLowerCase().includes(search) ||
        machine.baseInfo.ownerText.toLowerCase().includes(search)
      );
    };
  }

  machineIsAdded(machine: MachineListDto): boolean {
    if (!this.existingMachines.some(m => m.id == machine.id)) {
      return false;
    }

    return true;
  }

  onCheckboxChange(machine: MachineListDto, $event: any) {
    var addedMachineIndex = this.addedMachines.findIndex(m => m.id === machine.id);
    if (addedMachineIndex === -1) {

      this.addedMachines.push(
        {
          id: machine.id,
          machineType: MachineType.Harvester,
          machineTypeText: machine.baseInfo.machineTypeText,
          machineManufacturerText: machine.baseInfo.manufacturer,
          modelText: machine.baseInfo.model,
          machineId: machine.machineId,
          statusText: machine.baseInfo.machineStatusText,
          clientStatus: EditablePostClientStatus.New
        }
      );

      return;
    }

    this.addedMachines.splice(addedMachineIndex, 1);
  }

  onChangeShowDeactivatedMachines(checked: boolean) {
    this.showDeactivated = checked;

    if (this.showDeactivated) {
      this.machinesDataSource.data = this.allMachines.filter(m => m.baseInfo.machineStatusText);

      return;
    }

    this.machinesDataSource.data = this.allMachines.filter(m =>
      m.baseInfo.machineStatusText === MachineStatusLabels[MachineStatus.Active])
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.machinesDataSource.filter = filterValue.trim().toLowerCase();
  }

  private sortMachinesBasedOnAssignmentThenMachineId() {
    this.allMachines.sort((a, b) => {
      const aIsAssigned = this.machineIsAdded(a);
      const bIsAssigned = this.machineIsAdded(b);

      if (aIsAssigned !== bIsAssigned) {
        return bIsAssigned ? 1 : -1;
      }

      return a.machineId.localeCompare(b.machineId);
    });
  }

  onConfirm() {
    this.dialogRef.close(this.addedMachines);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
